import React from 'react'
import Spacing from '../componenets/UI/Spacing'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet'

export default function FutureMineralsIndustriesPage() {
  const { t } = useTranslation()
  return (
    <>
      <Helmet>
        <title>{`APFM | ${t('INDUSTRIES')}`}</title>
      </Helmet>
      <Spacing />
      <div className="app-container px-8 lg:px-0">
        <h2
          data-aos={`fade-down`}
          data-aos-delay={100}
          className="mb-4 text-2xl font-black"
        >
          {t('INDUSTRIES')}
        </h2>

        <div className="grid grid-cols-12 gap-4">
          {t('INDUSTRIES_LIST', { returnObjects: true }).map((industria) => (
            <div
              data-aos={`fade-up`}
              data-aos-delay={100}
              className="border-muted-300 relative col-span-12 min-h-[320px] border-2 bg-light p-4 lg:col-span-4"
            >
              <h1 className="text-2xl font-bold">{industria.TITLE}</h1>
              <h2 className="mt-2 font-bold text-info">{industria.SUB_TITLE}</h2>
              <div className="p-8">
                <ul className="list-disc space-y-1 text-third">
                  {industria.MINERALS.map((mineral) => (
                    <li>{mineral}</li>
                  ))}
                </ul>
              </div>
              <img
                className="absolute bottom-4 h-32 w-auto object-contain ltr:right-4 rtl:left-4"
                src={industria.ICON}
                alt=""
              />
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
